import { useState } from 'react';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './PujaVidhi.scss';

const pujaVidhiList = [
  {
    id: 1,
    name: 'Ganesh Puja Vidhi',
    img: 'https://www.jagranimages.com/images/newimg/15042020/15_04_2020-ganesha_puja_20191757.jpg',
    desc: 'Ganesh Puja is performed to remove obstacles and begin any auspicious task. It involves Ganesh mantra chanting, durva grass offering, and modak naivedyam.'
  },
  {
    id: 2,
    name: 'Durga Puja Vidhi',
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSRiXZG25sJ1oq-A3jsTZpqPI4Zv6sc32rIdg&s',
    desc: 'Durga Puja includes Kalash sthapana, chanting of Durga Saptashati, offering red flowers, and performing aarti during Navratri.'
  },
  {
    id: 3,
    name: 'Lakshmi Puja Vidhi',
    img: 'https://images.herzindagi.info/her-zindagi-hindi/images/2024/10/29/article/image/diwali-puja-vidhi-samagri-list-dipawali-puja-me-kya-kya-saman-lagega-and-rules-1730188457662.jpg',
    desc: 'Lakshmi Puja is performed on Diwali night with deepams, lotus flowers, sweets, and chanting of Lakshmi Sahasranama for wealth and prosperity.'
  },
  {
    id: 4,
    name: 'Saraswati Puja Vidhi',
    img: 'https://static.toiimg.com/thumb/msid-73659630,imgsize-122540,width-400,resizemode-4/73659630.jpg',
    desc: 'Saraswati Puja is done during Vasant Panchami with white flowers, books placed for blessing, and mantra recitation for wisdom and learning.'
  },
  {
    id: 5,
    name: 'Satyanarayan Puja Vidhi',
    img: 'https://www.sanatan.org/marathi/wp-content/uploads/sites/2/2015/05/1366297260_satyanarayan_puja_400.jpg',
    desc: 'This puja includes narration of Satyanarayan Katha, offering of banana and tulsi leaves, and preparation of sheera as prasad.'
  },
  {
    id: 6,
    name: 'Navagraha Puja Vidhi',
    img: 'https://www.thepackersmovers.com/blog/wp-content/uploads/2021/09/Navagraha-Puja-Benefits.jpg',
    desc: 'Navagraha puja is done to appease the nine planets with separate offerings and specific mantras to reduce negative planetary effects.'
  },
  {
    id: 7,
    name: 'Shiv Puja Vidhi',
    img: 'https://images.bhaskarassets.com/web2images/521/2024/03/03/shivling-pujan-1_1709463770.jpg',
    desc: 'Shiv Puja involves Abhishek with milk, water, honey, bilva leaves, and chanting of Om Namah Shivaya and Rudram.'
  },
  {
    id: 8,
    name: 'Kali Puja Vidhi',
    img: 'https://hindi.cdn.zeenews.com/hindi/sites/default/files/styles/zm_700x400/public/2022/10/24/1386761-kalichaudash.jpg?itok=15ohx9MF',
    desc: 'Kali Puja is performed on Amavasya with red hibiscus flowers, meat or sweets as offerings, and intense tantric mantras.'
  },
  {
    id: 9,
    name: 'Hanuman Puja Vidhi',
    img: 'https://www.lordhanuman.org/wp-content/uploads/2024/02/Hanuman-Puja-Vidhi-Puja-Muhurta-%E0%A4%AA%E0%A5%82%E0%A4%9C%E0%A4%BE-%E0%A4%AE%E0%A5%81%E0%A4%B9%E0%A5%82%E0%A4%B0%E0%A5%8D%E0%A4%A4-Hanuman-Puja-Significance-%E0%A4%B9%E0%A4%A8%E0%A5%81%E0%A4%AE%E0%A4%BE%E0%A4%A8-%E0%A4%AA%E0%A5%82%E0%A4%9C%E0%A4%BE-%E0%A4%AE%E0%A4%B9%E0%A4%A4%E0%A5%8D%E0%A4%B5.jpg',
    desc: 'Hanuman Puja includes applying sindoor and oil, chanting Hanuman Chalisa, and offering laddoos on Tuesdays or Saturdays.'
  },
  {
    id: 10,
    name: 'Rudrabhishek Vidhi',
    img: 'https://i0.wp.com/pujabooking.com/wp-content/uploads/2017/07/Rudrabhishek.jpg?fit=401%2C251&ssl=1',
    desc: 'Rudrabhishek is a powerful Shiv ritual done with continuous pouring of holy substances on Shivling while chanting Rudra mantras.'
  },
];

const PujaVidhi = () => {
  const [selectedPuja, setSelectedPuja] = useState(null);

  const openPopup = (puja) => {
    setSelectedPuja(puja);
  };

  const closePopup = () => {
    setSelectedPuja(null);
  };

  return (
    <div className="pujavidhicontainer">
      <InnerNav />
      <div className="pujavidhicontent">
        <Zodiac />

        <div className="festival-header">
          <h4>Puja Vidhi – Ritual Methods for Different Deities</h4>
        </div>

        <div className="festival-grid">
          {pujaVidhiList.map((item) => (
            <div className="festival-card" key={item.id} onClick={() => openPopup(item)}>
              <img
              src={item.img || 'https://bhaktvatsal-s3.s3.ap-south-1.amazonaws.com/uploads/image-279.webp'}
                alt={item.name}
              />
              <p>{item.name}</p>
            </div>
          ))}
        </div>

        {selectedPuja && (
          <div className="avatar-popup" onClick={closePopup}>
            <div className="avatar-popup-inner" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closePopup}>&times;</button>
              <h3>{selectedPuja.name}</h3>
              <img
              src={selectedPuja.img || 'https://bhaktvatsal-s3.s3.ap-south-1.amazonaws.com/uploads/image-279.webp'}
                alt={selectedPuja.name}
              />
              <p>{selectedPuja.desc}</p>
            </div>
          </div>
        )}

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default PujaVidhi;
